import { render, staticRenderFns } from "./customer-ledger.vue?vue&type=template&id=7962cd97&scoped=true&"
import script from "./customer-ledger.vue?vue&type=script&lang=js&"
export * from "./customer-ledger.vue?vue&type=script&lang=js&"
import style0 from "./customer-ledger.vue?vue&type=style&index=0&id=7962cd97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962cd97",
  null
  
)

export default component.exports